<style>
.PatternsTable .table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.PatternsTable .table__container--panel p {
  font-size: 12px;
}
.PatternsTable .table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.PatternsTable .table__container--filter {
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
  font-size: 12px;
}
</style>

<template>
  <v-layout
    row
    fill-height
    wrap
    class="PatternsTable"
  >
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout
      class="table__container--panel"
      wrap
    >
      <v-icon
        style="padding-left: 10px"
        title="Pobierz"
        @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event), resizeColumns()"
      >description</v-icon>
      <v-layout
        align-right
        justify-end
      >
        <div style="margin-top: auto; margin-bottom: auto;">
          <p style="line-height:29px">Liczba wyników: {{numberFiltered}}/{{numberAll}}</p>
        </div>
        <input
          type="text"
          class="table__container--filter"
          v-model="filter"
          placeholder="Treść filtra"
        >
      </v-layout>
      <div class="table__container--separator"></div>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../../shared/ExportTableData";

export default {
  name: "App",
  data: () => ({
    tableTitle: "PatternsTable",
    filter: "",
    numberAll: 0,
    numberFiltered: 0,
    columnDefs: [],
    dict: [],
    curvesList: [],
    patternsList: [],
  }),
  components: {
    AgGridVue,
    ExportTableData,
    Buttons: {
      template:
        '<span><v-icon small title="Wyświetl szczegóły" @click="showCurve">find_in_page</v-icon><v-icon small title="Usuń" @click="removeCurve">delete</v-icon></span>',
      methods: {
        showCurve() {
          this.params.context.componentParent.show(
            "CurveDetail"
          );
          this.$root.$emit('loadCurve', this.params.data);
        },
        removeCurve() {
          let id = this.params.data.id;
          this.$store.dispatch("deleteCurve", id).then(r => {
            if(r) {
              this.params.context.componentParent.loadData();
            } else {
              this.$root.$emit(
                "showSnackbar",
                "red",
                `${r}`
              );
            }
          });
        }
      },
    }
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        onFilterModified: this.filteredNumber,
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
  },
  beforeMount() {
    this.dict = [
      {
        headerName: "ID krzywej",
        field: "curve_id",
        sort: "asc",
        comparator: (a, b) => {
          var reA = /[^a-zA-Z]/g;
          var reN = /[^0-9]/g;
          var AInt = parseInt(a, 10);
          var BInt = parseInt(b, 10);
          if(isNaN(AInt) && isNaN(BInt)) {
            var aA = a.replace(reA, "");
            var bA = b.replace(reA, "");
            if(aA === bA) {
              var aN = parseInt(a.replace(reN, ""), 10);
              var bN = parseInt(b.replace(reN, ""), 10);
              return aN === bN ? 0 : aN > bN ? 1 : -1;
            } else {
              return aA > bA ? 1 : -1;
            }
          } else if(isNaN(AInt)) {//A is not an Int
            return 1;//to make alphanumeric sort first return 1 here
          } else if(isNaN(BInt)) {//B is not an Int
            return -1;//to make alphanumeric sort first return -1 here
          } else if(AInt == BInt) {
            var aA = a.replace(reA, "");
            var bA = b.replace(reA, "");
            return aA > bA ? 1 : -1;
          }
          else {
            return AInt > BInt ? 1 : -1;
          }
        }
      },
      {
        headerName: "Opis",
        field: "description",
        valueFormatter: this.nullValue
      }
    ];
    this.columnDefs = [
      {
        headerName: "",
        cellRendererFramework: "Buttons",
        minWidth: 50,
        width: 100
      }
    ];
    this.dict.forEach(field => {
      this.columnDefs.push(field);
    });
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    nullValue(params) {
      if(!params.value || params.value.length === 0) {
        params.value = "Brak opisu";
        return params.value;
      } else {
        return params.value;
      }
    },
    loadData() {
      this.$store.dispatch("getCurves").then(r => {
        this.numberAll = r.curves.length;
        this.numberFiltered = this.numberAll;
        let patterns = r.curves.filter(el => el.curve_type === 0)
        this.gridOptions.api.setRowData(patterns);
      })
    },
    showNoRowsMessage() {
      let dataSource = {
        getRows(params) {
          params.successCallback([], 0);
        }
      };
      this.gridOptions.api.setDatasource(dataSource);
      this.gridOptions.api.showNoRowsOverlay();
    },
    filteredNumber(e) {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    refreshGrid() {
      this.gridOptions.api.hideOverlay();
      this.gridOptions.api.setColumnDefs(this.columnDefs);
      this.numberAll = this.events.length;
      this.numberFiltered = this.numberAll;
    },
    onChanged() {}
  },
  mounted() {
    this.$root.$on("showNoRowsMessage", this.showNoRowsMessage);
    this.$root.$on("refreshPatterns", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/curves/PatternsTable.vue